import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    CollectionBillingProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DossierPrescriberProvider,
} from '@europrocurement/l2d-modules';
import {
    ordersBasePath,
    orderDetailPath,
    listeordersPath,
    ordersFacturationPath,
} from './constants';
import { OrderRoot, OrderDetail, ListeOrders } from './views';
import { FacturationTab } from '../Dossiers/components';
import OrderDuplicateWrapper from './views/detail/OrderDuplicateWrapper';

export const OrderRouter: RouteObject = {
    path: ordersBasePath,
    element: <OrderRoot />,
    handle: { title: 'Commandes' },
    children: [
        {
            path: listeordersPath,
            index: true,
            element: <ListeOrders />,
            handle: { title: 'Commandes - Liste' },
        },
        {
            path: orderDetailPath,
            element: <OrderDetail />,
            handle: { title: 'Commandes - Détails' },
        },
        {
            path: `${orderDetailPath}/duplication`,
            element: <OrderDuplicateWrapper />,
            handle: { title: 'Commandes - Duplication' },
        },
        {
            path: ordersFacturationPath,
            element: (
                <CollectionBillingProvider autoload={false}>
                    <DocumentPreviewProvider>
                        <DossierPrescriberProvider>
                            <FacturationTab />
                            <DocumentPreviewOverlay />
                        </DossierPrescriberProvider>
                    </DocumentPreviewProvider>
                </CollectionBillingProvider>
            ),
            handle: { title: 'Commandes - Facturation' },
        },
    ],
};
